import { LocalTypes } from '../types/ActionDrawer';

export default {
    namespaced: true,
    state: {
        open: false,
        contentComponent: 'div',
    },
    getters: {},
    actions: {},
    mutations: {
        [LocalTypes.mutations.SET_OPEN]: (state, open) => {
            state.open = open;
        },
        [LocalTypes.mutations.SET_CONTENT_COMPONENT]: (
            state,
            contentComponent,
        ) => {
            state.contentComponent = contentComponent;
        },
    },
};
